<template>
  <v-dialog v-model="dialog" max-width="400">
    <template v-slot:activator="{ attrs, on }">
      <v-btn v-on="on" v-bind="attrs" color="primary" block rounded>Sair</v-btn>
    </template>
    <v-card>
      <v-card-title>Sair do sistema?</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" rounded @click="logout" :loading="loading"
          >Sim, sair</v-btn
        >
        <v-btn text color="secondary" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dialog: false,
    loading: false,
  }),
  methods: {
    async logout() {
      this.loading = true;
      await axios
        .get(`/colaborador/logout`)
        .then((res) => {
          if (res.data.success) {
            sessionStorage.removeItem("userKey");
            this.$router.go();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
</style>